import { withI18n } from 'react-i18next';
import { withRouter } from 'react-router';

import { connect } from 'react-redux';

import {
  signInActions,
  activeAccountSel,
  isLoggedInSel
} from 'src/store/modules/signin';

import AccountMenu from './AccountMenu';
import { accountsSel, userActions, userDataSel } from 'src/store/modules/user';

const mapStateToProps = (state: any, ownProps: any) => {
  return {
    isLoggedIn: isLoggedInSel(state),
    accountID: activeAccountSel(state),
    showSwitchAccounts: accountsSel(state)
      ? accountsSel(state).length > 1
      : false,
    userData: userDataSel(state)
  };
};

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  signout: () => dispatch(signInActions.signout()),
  getAccounts: () => dispatch(userActions.getUserAccounts()),
  getUserData: () => dispatch(userActions.getUserDetails())
});

export const pureComponent = AccountMenu;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(withRouter(AccountMenu)));

interface IDispatchFromProps {
  signout(): void;
  getAccounts(): void;
  getUserData(): void;
}
